import type { TranslationOriginalDTO } from '../service/ai-translation.repository.interface';
import type { TranslationOriginalRequest } from '../type/ai-translation.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { TranslationOriginal } from '@/infrastructure/api-functions/interface/translation-original.interface';

@injectable()
export class TranslationOriginalDTOImpl implements TranslationOriginalDTO {
    constructor(
        @inject(TranslationOriginal)
        private readonly _translationOriginalApi: TranslationOriginal,
    ) { }

    async fetch(value: TranslationOriginalRequest): Promise<void> {
        const params = {
            current_step: value.currentStep,
            original_index: value.originalIndex,
            original_text: value.originalText,
            task_id: value.taskId,
        };
        await this._translationOriginalApi.translationOriginal(params);
    }
}
